import { render, staticRenderFns } from "./AdminCardsHierarchyPage.vue?vue&type=template&id=1003a9f4"
import script from "./AdminCardsHierarchyPage.vue?vue&type=script&lang=js"
export * from "./AdminCardsHierarchyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports